import { httpsCallable } from 'firebase/functions';

import { functions } from '../../../firebase.js';

const getClientFunctions = httpsCallable<void, string[]>(
  functions,
  'getClients'
);

export const getClients = async (params: void): Promise<Array<string>> => {
  const result = await getClientFunctions(params);
  return result.data ?? [];
};
